function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9991 9.86756L12.252 10.7412V1.36676C12.252 0.862764 12.6552 0.493164 13.1256 0.493164C13.596 0.493164 13.9991 0.896364 13.9991 1.36676V9.86756Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9991 15.7818L9.42946 16.9914C9.42946 16.9914 7.98466 17.4282 7.31266 15.7818C6.64066 14.1354 5.86786 12.1866 5.86786 12.1866C5.86786 12.1866 4.85986 9.96895 7.11106 8.86015C9.36226 7.75135 10.5047 10.1706 10.5047 10.1706L11.7143 12.9258L15.2759 12.0522C15.2759 12.0522 17.2583 11.6826 17.3927 13.7322V21.057L23.8103 18.6378C23.8103 18.6378 24.7511 18.4362 24.9191 16.9914C25.0199 15.7818 25.9607 15.7146 26.1623 15.7146C26.3975 15.7146 27.3719 15.7146 27.4391 16.9914C27.4727 18.8058 26.3303 20.4186 24.6503 21.0234C22.6679 21.7626 7.34626 27.4074 7.34626 27.4074C7.34626 27.4074 6.06946 27.777 5.66626 26.6682C5.26306 25.5594 6.40546 25.0554 6.40546 25.0554L13.9991 22.2666V15.7818Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.43858 7.54903C7.90457 7.54903 9.09298 6.36062 9.09298 4.89463C9.09298 3.42865 7.90457 2.24023 6.43858 2.24023C4.9726 2.24023 3.78418 3.42865 3.78418 4.89463C3.78418 6.36062 4.9726 7.54903 6.43858 7.54903Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.26439 9.96859C1.26439 9.96859 2.44039 9.46459 2.97799 10.5398C3.51559 11.615 6.33799 17.5286 6.33799 17.5286C6.33799 17.5286 6.84199 19.007 8.858 18.6374C9.19399 18.4694 9.52999 18.3686 9.86599 18.2678C10.4708 18.1334 11.2772 18.335 11.4788 19.1078C11.6468 19.7798 11.2772 20.4854 10.6388 20.7206C9.83239 21.023 8.99239 21.191 8.15239 21.2582C6.40519 21.191 4.82599 20.2166 4.01959 18.671C2.80999 16.3862 0.693194 11.615 0.693194 11.615C0.390794 10.9766 0.659594 10.271 1.26439 9.96859Z",
  fill: "current"
});

function SvgLifts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifts);
export default __webpack_public_path__ + "static/media/lifts.50bc0cc2.svg";
export { ForwardRef as ReactComponent };